import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import ClassNames from 'classnames'

interface IProps {
  current: string | number
  options: Array<{ label: string; id: string | number }>
  handleSelect(id: string | number): void
}

export const Tabs: React.FC<IProps> = ({ current, options = [], handleSelect }) => {
  const onClick = (id: string | number) => {
    handleSelect(id)
  }
  return (
    <TabsWrapper>
      {options.map(option => (
        <div
          className={ClassNames(['Tab', { active: current === option.id }])}
          key={option.id}
          onClick={() => onClick(option.id)}
        >
          {option.label}
        </div>
      ))}
    </TabsWrapper>
  )
}

const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  font-weight: bold;
  padding: 4px 16px;
  .Tab {
    border-bottom: 2px solid transparent;
    padding: 4px 16px;
    cursor: pointer;
    &.active {
      color: ${constants.COLORS.primary};
      border-bottom: 2px solid ${constants.COLORS.primary};
    }
  }
`
